import { Box, type BoxProps } from "@chakra-ui/react";
import { forwardRef } from "react";

// Card styles using design tokens
const cardStyles = {
  bg: "white",
  borderWidth: "1px",
  borderColor: "gray.200",
  borderRadius: "lg",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  _dark: { 
    bg: "gray.800", 
    borderColor: "gray.700",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.12)"
  },
  p: 6,
};

export interface CardProps extends BoxProps {
  children: React.ReactNode;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  function Card({ children, ...props }, ref) {
    return (
      <Box ref={ref} {...cardStyles} {...props}>
        {children}
      </Box>
    );
  }
);

export default Card; 